"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jquery = _interopRequireDefault(require("jquery"));

var _lodash = _interopRequireDefault(require("lodash"));

/** *
 * requireInputTypes
 */
var requireInputTypes = ['text', 'number', 'email', 'url', 'tel', 'date', 'week', 'datetime', 'datetime-local', 'image', 'month', 'time', 'password', 'range', 'search'];
/** *
 * insetMaterialLabel
 */

var insetMaterialLabel = {
  label: "<%if(label) {%>\n      <div class=\"label\">\n        <%if(require) {%><i class=\"require\"></i><%}%>\n        <%=label%>\n      </div>\n      <%}%>",
  input: '     <%=input%>'
};
/** *
 * rangeTipTemplate
 */

var rangeTipTemplate = _lodash["default"].template('<%=minLength%> / <%=maxLength%>');
/** *
 * templates
 */


var templates = {
  layout: {
    outset: _lodash["default"].template("<div class=\"ct-form-control <%=type%> <%=labelposition%> <%=labelalign%>\">\n           <div class=\"ct-form-control-inner\">\n             <div class=\"label\">\n             <%if(require) {%><i class=\"require\"></i><%}%>\n             <%=label%>\n             </div>\n             <div class=\"controlWrap <%=full%>\"><%=control%></div>\n           </div>\n           <div class=\"tooltipwrap\">\n              <div class=\"errormessage\"></div>\n              <div class=\"tooltipfixed\">\n              <%if(tooltip){%><div class=\"tooltip\"><%=tooltip%></div><%}%>\n              <%if(rangetip){%><div class=\"rangetip\"><%=rangetip%></div><%}%>\n              </div>\n           </div>\n        </div>"),
    inset: {
      "default": _lodash["default"].template("<div class=\"ct-form-control default labelleft labelinset\">\n             <div class=\"ct-form-control-inner\">\n               <%=control%>\n             </div>\n             <div class=\"tooltipwrap\">\n              <div class=\"errormessage\"></div>\n              <div class=\"tooltipfixed\">\n              <%if(tooltip){%><div class=\"tooltip\"><%=tooltip%></div><%}%>\n              <%if(rangetip){%><div class=\"rangetip\"><%=rangetip%></div><%}%>\n              </div>\n             </div>\n           </div>"),
      material: _lodash["default"].template("<div class=\"ct-form-control material labelleft labelinset\">\n             <div class=\"ct-form-control-inner\">\n               <%=control%>\n             </div>\n             <div class=\"tooltipwrap\">\n              <div class=\"errormessage\"></div>\n              <div class=\"tooltipfixed\">\n              <%if(tooltip){%><div class=\"tooltip\"><%=tooltip%></div><%}%>\n              <%if(rangetip){%><div class=\"rangetip\"><%=rangetip%></div><%}%>\n              </div>\n             </div>\n           </div>")
    }
  },
  controls: {
    clearinput: _lodash["default"].template("<div class=\"ct-form-clearinput <%=type%> <%=full%>\">\n           <div class=\"inner <%=labelalign%>\">\n             <%if(inset && type === \"material\"){%>\n             ".concat(insetMaterialLabel.input + insetMaterialLabel.label, "\n             <%}else{%>\n             ").concat(insetMaterialLabel.label + insetMaterialLabel.input, "\n             <%}%>\n             <%if(border){%><div class=\"border\"></div><%}%>\n           </div>\n           <div class=\"ct-form-tool\"><span class=\"clear\"></span></div>\n        </div>")),
    pwdtoggle: _lodash["default"].template("<div class=\"ct-form-clearinput ct-form-pwdtoggle <%=type%> <%=full%>\">\n           <div class=\"inner <%=labelalign%>\">\n             <%if(inset && type === \"material\"){%>\n             ".concat(insetMaterialLabel.input + insetMaterialLabel.label, "\n             <%}else{%>\n             ").concat(insetMaterialLabel.label + insetMaterialLabel.input, "\n             <%}%>\n             <%if(border){%><div class=\"border\"></div><%}%>\n           </div>\n           <div class=\"ct-form-tool\">\n             <span class=\"toggle\"></span>\n             <span class=\"clear\"></span>\n           </div>\n        </div>")),
    autoheighttextarea: _lodash["default"].template("<div class=\"ct-form-expandingarea <%=type%> <%=full%>\">\n           <div class=\"inner <%=labelalign%>\">\n              <%if(label) {%>\n              <div class=\"label\">\n                <%if(require) {%><i class=\"require\"></i><%}%>\n                <%=label%>\n              </div>\n              <%}%>\n              <div class=\"ct-form-expandingarea-inner\">\n               <pre><span></span><br></pre>\n               <%=input%>\n              </div>\n              <%if(border){%><div class=\"border\"></div><%}%>\n           </div>\n        </div>"),
    select: _lodash["default"].template("<div class=\"ct-form-select <%=type%> <%=full%>\">\n           <div class=\"inner <%=labelalign%>\">\n              <%if(label) {%>\n              <div class=\"label\">\n                <%if(require) {%><i class=\"require\"></i><%}%>\n                <%=label%>\n              </div>\n              <%}%>\n              <%=input%>\n              <%if(border){%><div class=\"border\"></div><%}%>\n           </div>\n         </div>"),
    radio: _lodash["default"].template("<div class=\"ct-form-radio <%=type%>\">\n           <%=input%>\n           <div class=\"radio\">\n              <div class=\"inner\"></div>\n           </div>\n         </div>"),
    checkbox: _lodash["default"].template("<div class=\"ct-form-checkbox <%=type%>\">\n           <%=input%>\n           <div class=\"checkbox\"></div>\n         </div>"),
    "switch": _lodash["default"].template("<div class=\"ct-form-switch <%=type%>\">\n           <%=input%>\n           <div class=\"checkbox\"></div>\n         </div>"),
    slider: _lodash["default"].template("<div class=\"ct-form-slider <%=type%>\">\n          <%=input%>\n         </div>"),
    spinner: _lodash["default"].template("<div class=\"ct-form-spinner <%=type%>\">\n           <%=input%>\n           <a class=\"minus\"></a>\n           <a class=\"plus\"></a>\n         </div>"),
    radiogroup: _lodash["default"].template("<div class=\"ct-form-radiogroup-wrap <%=type%>\">\n           <%=input%>\n         </div>"),
    checkboxgroup: _lodash["default"].template("<div class=\"ct-form-checkboxgroup-wrap <%=type%>\">\n           <%=input%>\n         </div>")
  }
};
/** *
 * containers
 */

var containers = {
  // 自动适应高的textarea
  autoheighttextarea: renderAutoheighttextarea,
  // 带清除功能的input
  clearinput: renderClearinput,
  // 带有眼睛的password
  pwdtoggle: renderPwdToggle,
  // select
  select: renderSelect,
  // radio
  radio: renderRadio,
  // checkbox
  checkbox: renderCheckbox,
  // switch
  "switch": renderSwitch,
  // slider
  slider: renderSlider,
  // spinner
  spinner: renderSpinner,
  // radiogroup
  radiogroup: renderRadioGroup,
  // checkboxgroup
  checkboxgroup: renderCheckboxGroup
};
/** *
 * _validateChainConfig
 */

var validateChainConfig = [{
  isValidate: ['data-ctform-config-require'],
  validate: RequireChain
}, {
  isValidate: ['data-ctform-config-minlength', 'data-ctform-config-maxlength'],
  validate: PatternChain
}, {
  isValidate: ['data-ctform-config-pattern'],
  validate: LengthChain
}];
/**
 * patterns
 */

var patterns = {// // 数字
  // 'digit': /^[-]?\d+$/,
  // // email
  // 'email': /^\w+((-\w+)|(\.\w+))*\\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/,
  // // phone
  // 'phone': /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
  // // tel
  // 'tel': /^\d+(-\d+)*$/,
  // // 身份证
  // 'idcard': /^[1-9]\d{5}(19\d{2}|[2-9]\d{3})((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])(\d{4}|\d{3}X)$/,
  // // 中文
  // 'chinese': /^[\u4E00-\u9FA5]+$/,
  // // 文件名的校验
  // 'file': /[^\\\\/:\\*\\?"<>@#%￥《》|$!^&~]/
};
/**
 * makeExpandingArea
 * outset inset 两种模式
 * @param {HtmlElement} textarea
 * @param {string} type
 * @access private
 */

function makeExpandingArea(textarea, type) {
  var isRender = textarea.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = textarea.dataset.ctformConfigName;
  var container = createContainer(textarea, type, function (parent) {
    var dom = parent.querySelector('textarea');
    dom.parentNode.replaceChild(textarea.cloneNode(true), dom);
  });
  var textAreaDom = container.querySelector('textarea');
  var spanDom = container.querySelector('span');
  var rangetipDom = container.querySelector('.rangetip');
  var maxLangth;

  if (rangetipDom) {
    maxLangth = window.parseInt(textAreaDom.dataset.ctformConfigMaxlength);
    textAreaDom.setAttribute('maxlength', "".concat(maxLangth));
  }

  var ctFormExpandingareaInner = container.querySelector('.ct-form-expandingarea-inner');
  textAreaDom.dataset.render = 'true';
  textAreaDom.addEventListener('input', function () {
    spanDom.textContent = textAreaDom.value;

    if (rangetipDom) {
      if (this.value.length <= maxLangth) {
        rangetipDom.innerText = rangeTipTemplate({
          minLength: this.value.length,
          maxLength: maxLangth
        });
      }
    }
  }, false);
  textAreaDom.addEventListener('focus', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }

    if (textarea.dataset.ctformConfigInset) {
      if (!ctFormExpandingareaInner.classList.contains('focus')) {
        ctFormExpandingareaInner.classList.add('focus');
      }
    }
  });
  textAreaDom.addEventListener('blur', function () {
    if (textarea.dataset.ctformConfigInset) {
      if (ctFormExpandingareaInner.classList.contains('focus')) {
        ctFormExpandingareaInner.classList.remove('focus');
      }
    }
  });
  spanDom.textContent = textAreaDom.value;
  container.querySelector('.ct-form-expandingarea').className += ' active';
}
/**
 * makeClearInput
 * @param {HTMLElement} input
 * @param {string} type
 * @access private
 */


function makeClearInput(input, type) {
  var isRender = input.dataset.render;
  if (isRender) return false;
  var container = createContainer(input, type, function (parent) {
    var dom = parent.querySelector('input');
    dom.parentNode.replaceChild(input.cloneNode(true), dom);
  });
  var inputDom = container.querySelector('input');
  inputDom.dataset.render = 'true';
  clearInputEvent.call(this, container);
}
/**
 * makePwdToggle
 * @param {HTMLElement} password
 * @param {string} type
 * @access private
 */


function makePwdToggle(password, type) {
  var isRender = password.dataset.render;
  if (isRender) return false;
  var container = createContainer(password, type, function (parent) {
    var dom = parent.querySelector('input');
    dom.parentNode.replaceChild(password.cloneNode(true), dom);
  });
  var passwordDom = container.querySelector('input');
  passwordDom.dataset.render = 'true';
  var toggleDom = container.querySelector('.toggle');
  toggleDom.addEventListener('click', function () {
    if (toggleDom.classList.contains('close')) {
      passwordDom.type = 'password';
      toggleDom.classList.remove('close');
    } else {
      passwordDom.type = 'text';
      toggleDom.classList.add('close');
    }
  }, false);
  clearInputEvent.call(this, container);
}
/**
 * makeSelect
 * @param {HTMLElement} select
 * @param {string} type
 * @access private
 */


function makeSelects(select, type) {
  var isRender = select.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = select.dataset.ctformConfigName;
  var container = createContainer(select, type, function (parent) {
    var dom = parent.querySelector('select');
    dom.parentNode.replaceChild(select.cloneNode(true), dom);
  });
  var selectDom = container.querySelector('select');
  selectDom.value = select.value;
  selectDom.dataset.render = 'true';
  selectDom.addEventListener('focus', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }
  });
}
/**
 * makeRadioGroups
 * @param {HtmlElement} radioGroup
 * @param {string} type
 * @access private
 */


function makeRadioGroups(radioGroup, type) {
  var isRender = radioGroup.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = radioGroup.dataset.ctformConfigName;
  var container = createContainer(radioGroup, type, function (parent) {
    var dom = parent.querySelector('.ct-form-radiogroup');
    dom.parentNode.replaceChild(radioGroup.cloneNode(true), dom);
  });
  var radioGroupDom = container.querySelector('.ct-form-radiogroup');
  radioGroupDom.dataset.render = 'true';
  radioGroupDom.addEventListener('click', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }
  });
}
/**
 * makeCheckboxGroup
 * @param {HtmlElement} checkboxGroup
 * @param {string} type
 * @access private
 */


function makeCheckboxGroup(checkboxGroup, type) {
  var isRender = checkboxGroup.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = checkboxGroup.dataset.ctformConfigName;
  var container = createContainer(checkboxGroup, type, function (parent) {
    var dom = parent.querySelector('.ct-form-checkboxgroup');
    dom.parentNode.replaceChild(checkboxGroup.cloneNode(true), dom);
  });
  var checkboxGroupDom = container.querySelector('.ct-form-checkboxgroup');
  checkboxGroupDom.dataset.render = 'true';
  checkboxGroupDom.addEventListener('click', function () {
    self.hideErrorMessageTip(name);
  });
}
/**
 * makeCheckbox
 * @param {HtmlElement} checkbox
 * @param {string} type
 * @access private
 */


function makeCheckboxs(checkbox, type) {
  var isRender = checkbox.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = checkbox.dataset.ctformConfigName;
  var container = createContainer(checkbox, type, function (parent) {
    var dom = parent.querySelector('input[type="checkbox"]');
    dom.parentNode.replaceChild(checkbox.cloneNode(true), dom);
  });
  var checkboxDom = container.querySelector('input[type="checkbox"]');
  checkboxDom.dataset.render = 'true';
  container.addEventListener('click', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }

    if (checkboxDom.disabled || checkboxDom.readOnly) return false;

    if (checkboxDom.checked) {
      checkboxDom.checked = false;
    } else {
      checkboxDom.checked = true;
    }
  });
}
/**
 * makeRadios
 * @param {HtmlElement} radio
 * @param {string} type
 * @access private
 */


function makeRadios(radio, type) {
  var isRender = radio.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = radio.dataset.ctformConfigName;
  var container = createContainer(radio, type, function (parent) {
    var dom = parent.querySelector('input[type="radio"]');
    dom.parentNode.replaceChild(radio.cloneNode(true), dom);
  });
  var radioDom = container.querySelector('input[type="radio"]');
  radioDom.dataset.render = 'true';
  container.addEventListener('click', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }

    if (radioDom.disabled || radioDom.readOnly) return false;

    if (radioDom.checked) {
      radioDom.checked = false;
    } else {
      radioDom.checked = true;
    }
  });
}
/**
 * makeSwitchs
 * @param {HtmlElement} checkbox
 * @param {string} type
 * @access private
 */


function makeSwitchs(checkbox, type) {
  var isRender = checkbox.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = checkbox.dataset.ctformConfigName;
  var container = createContainer(checkbox, type, function (parent) {
    var dom = parent.querySelector('input[type="checkbox"]');
    dom.parentNode.replaceChild(checkbox.cloneNode(true), dom);
  });
  var checkboxDom = container.querySelector('input[type="checkbox"]');
  checkboxDom.dataset.render = 'true';
  container.addEventListener('click', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }

    if (checkboxDom.disabled || checkboxDom.readOnly) return false;

    if (checkboxDom.checked) {
      checkboxDom.checked = false;
    } else {
      checkboxDom.checked = true;
    }
  });
}
/**
 * makeSliders
 * @param {HtmlElement} slider
 * @param {string} type
 * @access private
 */


function makeSliders(slider, type) {
  var isRender = slider.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = slider.dataset.ctformConfigName;
  var container = createContainer(slider, type, function (parent) {
    var dom = parent.querySelector('input[type="range"]');
    dom.parentNode.replaceChild(slider.cloneNode(true), dom);
  });
  var sliderDom = container.querySelector('input[type="range"]');
  sliderDom.dataset.render = 'true';
  sliderDom.addEventListener('focus', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }
  });
}
/**
 * makeSpinner
 * @param {HtmlElement} spinner
 * @param {string} type
 * @access private
 */


function makeSpinners(spinner, type) {
  var isRender = spinner.dataset.render;
  if (isRender) return false;
  var self = this;
  var name = spinner.dataset.ctformConfigName;
  var container = createContainer(spinner, type, function (parent) {
    var dom = parent.querySelector('input[type="number"].ios');
    dom.parentNode.replaceChild(spinner.cloneNode(true), dom);
  });
  var min = window.parseInt(spinner.getAttribute('min')) || 1;
  var max = window.parseInt(spinner.getAttribute('max')) || 100;
  var setp = window.parseInt(spinner.getAttribute('setp')) || 1;
  var value = window.parseInt(spinner.value) || 0;
  container.querySelector('.ct-form-spinner').className += spinner.className;
  var spinnerDom = container.querySelector('input[type="number"].ios');
  var plusDom = container.querySelector('.plus');
  var minusDom = container.querySelector('.minus');
  spinnerDom.dataset.render = 'true'; // plus

  plusDom.addEventListener('click', function () {
    self.hideErrorMessageTip(name);
    if (spinnerDom.disabled || spinnerDom.readOnly) return false;
    if (value >= max) return false;

    if (value + setp > max) {
      value += value + setp - max;
    } else {
      value += setp;
    }

    spinnerDom.value = value;
  }); // minus

  minusDom.addEventListener('click', function () {
    self.hideErrorMessageTip(name);
    if (spinnerDom.disabled || spinnerDom.readOnly) return false;
    if (value <= min) return false;

    if (value - setp < min) {
      value -= setp - min;
    } else {
      value -= setp;
    }

    spinnerDom.value = value;
  });
}
/**
 * 渲染高度自适应的textarea
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderAutoheighttextarea(container, type) {
  var areas = container.querySelectorAll('textarea');
  var l = areas.length;

  while (l--) {
    makeExpandingArea.call(this, areas[l], type);
  }
}
/**
 * 渲染带有删除操作的input
 <input type="button">
 <input type="checkbox">
 <input type="color">
 <input type="file">
 <input type="hidden">
 <input type="radio">
 <input type="reset">
 <input type="submit">
 <input type="email">
 <input type="text">
 <input type="number">
 <input type="tel">
 <input type="url">
 <input type="date">
 <input type="week">
 <input type="datetime">
 <input type="datetime-local">
 <input type="image">
 <input type="month">
 <input type="time">
 <input type="password">
 <input type="range">
 <input type="search">
 *
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderClearinput(container, type) {
  var input = container.querySelectorAll("input[type=\"text\"],\n     input[type=\"number\"]:not(.ios),\n     input[type=\"email\"],\n     input[type=\"url\"],\n     input[type=\"tel\"],\n     input[type=\"date\"],\n     input[type=\"week\"],\n     input[type=\"datetime\"],\n     input[type=\"datetime-local\"],\n     input[type=\"image\"],\n     input[type=\"month\"],\n     input[type=\"time\"],\n     input[type=\"search\"]");
  var l = input.length;

  while (l--) {
    makeClearInput.call(this, input[l], type);
  }
}
/**
 * 渲染password
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderPwdToggle(container, type) {
  var passwords = container.querySelectorAll('input[type="password"]');
  var l = passwords.length;

  while (l--) {
    makePwdToggle.call(this, passwords[l], type);
  }
}
/**
 * 渲染checkbox
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderCheckbox(container, type) {
  var checkboxs = container.querySelectorAll('input[type="checkbox"]:not(.switch)');
  var l = checkboxs.length;

  while (l--) {
    makeCheckboxs.call(this, checkboxs[l], type);
  }
}
/**
 * 渲染radio
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderRadio(container, type) {
  var radios = container.querySelectorAll('input[type="radio"]');
  var l = radios.length;

  while (l--) {
    makeRadios.call(this, radios[l], type);
  }
}
/**
 * 渲染switch
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderSwitch(container, type) {
  var switchs = container.querySelectorAll('input[type="checkbox"].switch');
  var l = switchs.length;

  while (l--) {
    makeSwitchs.call(this, switchs[l], type);
  }
}
/**
 * 渲染slider
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderSlider(container, type) {
  var slider = container.querySelectorAll('input[type="range"]');
  var l = slider.length;

  while (l--) {
    makeSliders.call(this, slider[l], type);
  }
}
/**
 * 渲染spinner
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderSpinner(container, type) {
  var spinner = container.querySelectorAll('input[type="number"].ios');
  var l = spinner.length;

  while (l--) {
    makeSpinners.call(this, spinner[l], type);
  }
}
/**
 * renderSelect
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderSelect(container, type) {
  var select = container.querySelectorAll('select');
  var l = select.length;

  while (l--) {
    makeSelects.call(this, select[l], type);
  }
}
/**
 * renderRadioGroup
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderRadioGroup(container, type) {
  var radiogroup = container.querySelectorAll('.ct-form-radiogroup');
  var l = radiogroup.length;

  while (l--) {
    makeRadioGroups.call(this, radiogroup[l], type);
  }
}
/**
 * renderCheckboxGroup
 * @param {HtmlElement} container
 * @param {string} type
 * @access private
 */


function renderCheckboxGroup(container, type) {
  var checkboxgroup = container.querySelectorAll('.ct-form-checkboxgroup');
  var l = checkboxgroup.length;

  while (l--) {
    makeCheckboxGroup.call(this, checkboxgroup[l], type);
  }
}
/**
 * clearInputEvent
 * @param {HtmlElement} container
 * @access private
 */


function clearInputEvent(container) {
  var self = this;
  var inputDom = container.querySelector('input');
  var clearDom = container.querySelector('.clear');
  var labelDom = container.querySelector('.label');
  var rangetipDom = container.querySelector('.rangetip');
  var name = inputDom.dataset.ctformConfigName;
  var maxLangth;

  if (rangetipDom) {
    maxLangth = window.parseInt(inputDom.dataset.ctformConfigMaxlength);
    inputDom.setAttribute('maxlength', "".concat(maxLangth));
  }

  clearDom.addEventListener('click', function () {
    inputDom.value = '', inputDom.focus(), clearDom.style.display = 'none';

    if (inputDom.dataset.ctformConfigInset && inputDom.dataset.ctformConfigType === 'material') {
      labelDom.classList.remove('animate');
    }
  }, false);
  inputDom.addEventListener('input', function () {
    if (rangetipDom) {
      if (this.value.length <= maxLangth) {
        rangetipDom.innerText = rangeTipTemplate({
          minLength: this.value.length,
          maxLength: maxLangth
        });
      }
    }

    inputDom.value ? clearDom.style.display = 'block' : clearDom.style.display = 'none';

    if (inputDom.dataset.ctformConfigInset && inputDom.dataset.ctformConfigType === 'material') {
      if (!this.value) {
        labelDom.classList.remove('animate');
      } else if (!labelDom.classList.contains('animate')) {
        labelDom.classList.add('animate');
      }
    }
  }, false);
  inputDom.addEventListener('focus', function (e) {
    if (!e.relatedTarget) {
      self.hideErrorMessageTip(name);
    }

    if (inputDom.dataset.ctformConfigInset && inputDom.dataset.ctformConfigType === 'material') {
      labelDom.classList.add('animate');
    }
  });
  inputDom.addEventListener('blur', function () {
    if (inputDom.dataset.ctformConfigInset && inputDom.dataset.ctformConfigType === 'material') {
      if (this.value) return;
      labelDom.classList.remove('animate');
    }
  });
}
/**
 * createContainer
 * @param {HtmlElement} dom
 * @param {string} type
 * @param {Function} replaceSelfCallback
 * @access private
 */


function createContainer(dom, type, replaceSelfCallback) {
  var templateStr;
  var domClone = dom.cloneNode(true);

  if (!domClone.classList.contains(dom.dataset.ctformConfigType || 'default')) {
    domClone.classList.add(dom.dataset.ctformConfigType || 'default');
  }

  var domType = dom.dataset.ctformConfigType || 'default';

  if (dom.dataset.ctformConfigInset) {
    /** *
     * 有inset的type
     * autoheighttextarea default
     clearinput default material
     pwdtoggle default material
     select default
     */
    if (domType !== 'default' && domType !== 'material') {
      domType = 'default';
    }

    templateStr = templates.layout.inset[domType]({
      tooltip: dom.dataset.ctformConfigTooltip ? dom.dataset.ctformConfigTooltip : '',
      rangetip: getRangeTip(dom),
      control: templates.controls[type]({
        type: domType,
        input: domClone.outerHTML || '',
        full: dom.dataset.ctformConfigFull || '',
        labelalign: dom.dataset.ctformConfigLabelalign || '',
        label: dom.dataset.ctformConfigLabel || '',
        require: dom.dataset.ctformConfigRequire || '',
        border: domType !== 'material',
        inset: true
      })
    });
  } else {
    templateStr = templates.layout.outset({
      type: domType,
      labelposition: dom.dataset.ctformConfigLabelposition || '',
      labelalign: dom.dataset.ctformConfigLabelalign || '',
      require: dom.dataset.ctformConfigRequire || '',
      label: dom.dataset.ctformConfigLabel || '',
      full: dom.dataset.ctformConfigFull || '',
      tooltip: dom.dataset.ctformConfigTooltip ? dom.dataset.ctformConfigTooltip : '',
      rangetip: getRangeTip(dom),
      control: templates.controls[type]({
        type: domType,
        input: domClone.outerHTML || '',
        full: '',
        labelalign: '',
        label: '',
        require: false,
        border: false,
        inset: false
      })
    });
  } // 如果type是group去掉data-ctform-config-require='require'


  if (type.lastIndexOf('group') !== -1) {
    var tempDom = createDomByHtml(templateStr);
    var groupTempDom = tempDom.querySelector('.ct-form-radiogroup,.ct-form-checkboxgroup');
    groupTempDom.innerHTML = groupTempDom.innerHTML.replace(/data-ctform-config-require=["']require["']/igm, '');
    templateStr = tempDom.outerHTML;
  }

  var container = createDomByHtml(templateStr);

  if (replaceSelfCallback) {
    replaceSelfCallback(container);
  }

  dom.parentNode.replaceChild(container, dom);
  return container;
}
/**
 * 根据字符串创建dom
 * @param {string} html
 * @returns {HtmlElement}
 * @access private
 */


function createDomByHtml(html) {
  var dom = document.createElement('div');
  dom.innerHTML = html;
  return dom.firstChild;
}
/**
 * getRangeTip
 * @param {HtmlElement} dom
 * @return {Object}
 * @access private
 */


function getRangeTip(dom) {
  var maxLength = dom.dataset.ctformConfigMaxlength;
  maxLength = parseInt(maxLength);
  var result = '';

  if (!isNaN(maxLength)) {
    result = rangeTipTemplate({
      minLength: 0,
      maxLength: maxLength
    });
  }

  return result;
}
/**
 * parentUntil
 * @param {HtmlElement} el
 * @param {string} className
 * @return {HtmlElement}
 * @access private
 */


function parentUntil(el, className) {
  if (!className || !el) return null;
  var element = null,
      parent = el;

  var popup = function popup() {
    if (parent.classList.contains(className)) {
      element = parent;
    } else if (parent !== document.body) {
      parent = parent.parentElement;
      popup();
    }
  };

  popup();
  return element;
}
/**
 * requireChain
 * 只验证输入类型，group，其他不验证
 * @param {HtmlElement} validateDom
 * @return {boolean}
 * @access private
 */


function RequireChain(validateDom) {
  // 输入类型的判断value
  // radioGroup 是否有input radio选中
  // checkboxGroup 是否有input checkbox选中
  var flag = false;
  var tagName = validateDom.tagName.toLowerCase();
  var inputType, groupName, name;

  if (tagName === 'input') {
    inputType = validateDom.type;

    if (requireInputTypes.indexOf(inputType) !== -1) {
      // 满足条件的input才行
      if (validateDom.value && validateDom.value.trim()) {
        flag = true;
      }
    }
  } else if (tagName === 'textarea') {
    if (validateDom.value && validateDom.value.trim()) {
      flag = true;
    }
  } else if (validateDom.classList.contains('ct-form-radiogroup') || validateDom.classList.contains('ct-form-checkboxgroup')) {
    groupName = validateDom.dataset.ctformConfigGroupname;

    if (validateDom.classList.contains('ct-form-radiogroup')) {
      if (validateDom.querySelector("input[type=\"radio\"][name=\"".concat(groupName, "\"]:checked"))) {
        flag = true;
      }
    } else if (validateDom.classList.contains('ct-form-checkboxgroup')) {
      if (validateDom.querySelectorAll("input[type=\"checkbox\"][name=\"".concat(groupName, "\"]:checked")).length !== 0) {
        flag = true;
      }
    }
  } else {
    flag = true;
  } // 有没填的项


  if (!flag) {
    name = validateDom.dataset.ctformConfigName;
    this.showErrorTip(name, validateDom.dataset.ctformConfigRequiremessage);
  }

  return flag;
}
/**
 * LengthChain
 * @param {HtmlElement} validateDom
 * @return {boolean}
 * @access private
 */


function LengthChain(validateDom) {
  var flag = false;
  var value; // = validateDom.value.trim();

  var tagName = validateDom.tagName.toLowerCase();
  var inputType;
  var name;
  var minlength = window.parseInt(validateDom.dataset.ctformConfigMinlength);
  var maxlength = window.parseInt(validateDom.dataset.ctformConfigMaxlength);

  if (!isNaN(minlength) && !isNaN(maxlength)) {
    if (tagName === 'input') {
      inputType = validateDom.type;

      if (requireInputTypes.indexOf(inputType) !== -1) {
        value = validateDom.value.trim(); // 验证length

        if (value.length >= minlength && value.length <= maxlength) {
          flag = true;
        }
      }
    } else if (tagName === 'textarea') {
      // 验证length
      value = validateDom.value.trim(); // 验证length

      if (value.length >= minlength && value.length <= maxlength) {
        flag = true;
      }
    } else {
      flag = true;
    }
  } else {
    flag = true;
  } // 有没填的项


  if (!flag) {
    name = validateDom.dataset.ctformConfigName;
    this.showErrorTip(name, validateDom.dataset.ctformConfigLengthmessage);
  }

  return flag;
}
/**
 * PatternChain
 * @param {HtmlElement} validateDom
 * @return {boolean}
 * @access private
 */


function PatternChain(validateDom) {
  var flag = false;
  var value;
  var tagName = validateDom.tagName.toLowerCase();
  var inputType;
  var name;
  var pattern = validateDom.dataset.ctformConfigPattern;
  var RegExp = patterns[pattern] ? patterns[pattern] : pattern ? new RegExp(pattern) : '';

  if (tagName === 'input') {
    inputType = validateDom.type;

    if (requireInputTypes.indexOf(inputType) !== -1) {
      value = validateDom.value.trim(); // 验证pattern

      flag = RegExp ? RegExp.test(value) : true;
    }
  } else if (tagName === 'textarea') {
    // 验证pattern
    value = validateDom.value.trim();
    flag = RegExp ? RegExp.test(value) : true;
  } else {
    flag = true;
  } // 有没填的项


  if (!flag) {
    name = validateDom.dataset.ctformConfigName;
    this.showErrorTip(name, validateDom.dataset.ctformConfigPatternmessage);
  }

  return flag;
}
/**
 * validateChain
 * @param validateDom
 * @return {boolean}
 * @access private
 */


function validateChain(validateDom) {
  var isValidate;
  var validate;
  var loopFlag = true;
  var isValidateFlag = false;

  for (var i = 0; i < validateChainConfig.length; i++) {
    isValidate = validateChainConfig[i].isValidate;
    validate = validateChainConfig[i].validate;

    for (var j = 0; j < isValidate.length; j++) {
      if (validateDom.hasAttribute(isValidate[j])) {
        isValidateFlag = true;
        break;
      }
    } // 需要验证才验证


    if (isValidateFlag) {
      loopFlag = validate.call(this, validateDom);

      if (!loopFlag) {
        break;
      }
    }
  }

  return loopFlag;
}
/**
 * validate form
 * @param {boolean} stopPropagation
 * @access private
 */


function validate(stopPropagation) {
  this.hideErrorMessageAllTips();
  var validateDoms = this.el.querySelectorAll("[data-ctform-config-require],\n     [data-ctform-config-pattern],\n     [data-ctform-config-maxlength],\n     [data-ctform-config-minlength]");
  var validateDom;
  var loopFlag = true;
  var flag = true;
  var firstValidateDom;

  for (var i = 0; i < validateDoms.length; i++) {
    validateDom = validateDoms[i];

    if (validateDom.disabled || validateDom.readOnly) {
      loopFlag = true;
    } else {
      loopFlag = validateChain.call(this, validateDom);
    }

    if (!loopFlag) {
      if (flag) {
        firstValidateDom = validateDom;
      }

      flag = false;
      if (stopPropagation) break;
    }
  }

  if (firstValidateDom) {
    firstValidateDom.focus();
  }

  return flag;
}
/**
 * _showTip
 * @param {string} name
 * @param {string} tip
 * @param {string} type [tooltip | errortip | successtip | rangetip]
 * @access private
 */


function showTip(name, tip, type) {
  var dom = this.el.querySelector("[data-ctform-config-name=\"".concat(name, "\"]"));
  if (!dom) return false;
  var parentDom = parentUntil(dom, 'ct-form-control');
  if (!parentDom) return false;
  var $parent = (0, _jquery["default"])(parentDom);
  var tipDom;

  if (type === 'errortip' || type === 'successtip') {
    if (type === 'errortip') {
      parentDom.classList.add('validerror');
    } else {
      parentDom.classList.add('validsuccess');
    }

    tipDom = $parent.find(' > .tooltipwrap > .errormessage')[0];
  } else if (type === 'tooltip') {
    tipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .tooltip')[0];
  } else if (type === 'rangetip') {
    tipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .rangetip')[0];
  }

  if (!tipDom) return false;
  tipDom.innerText = tip;
  tipDom.style.display = 'block';
}
/**
 * hideTip
 * @param {string} name
 * @param {string} type [tooltip | errortip | rangetip]
 * @access private
 */


function hideTip(name, type) {
  var dom = this.el.querySelector("[data-ctform-config-name=\"".concat(name, "\"]"));
  if (!dom) return false;
  var parentDom = parentUntil(dom, 'ct-form-control');
  if (!parentDom) return false;
  var $parent = (0, _jquery["default"])(parentDom);
  var errorTipDom;
  var toolTipDom;
  var rangeTipDom;

  if (type === 'errortip') {
    parentDom.classList.remove('validerror');
    parentDom.classList.remove('validsuccess');
    errorTipDom = $parent.find(' > .tooltipwrap > .errormessage')[0];
  } else if (type === 'tooltip') {
    toolTipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .tooltip')[0];
  } else if (type === 'rangetip') {
    rangeTipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .rangetip')[0];
  } else if (type === 'alltip') {
    parentDom.classList.remove('validerror');
    parentDom.classList.remove('validsuccess');
    errorTipDom = $parent.find(' > .tooltipwrap > .errormessage')[0];
    toolTipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .tooltip')[0];
    rangeTipDom = $parent.find(' > .tooltipwrap > .tooltipfixed > .rangetip')[0];
  }

  if (errorTipDom) {
    errorTipDom.innerText = '';
    errorTipDom.style.display = 'none';
  }

  if (toolTipDom) {
    toolTipDom.innerText = '';
    toolTipDom.style.display = 'none';
  }

  if (rangeTipDom) {
    rangeTipDom.innerText = '';
    rangeTipDom.style.display = 'none';
  }
}
/**
 * init
 * @access private
 */


function init() {
  /** *
   * 渲染指定元素的区域内的组件
   */
  var grouptypes = [];
  var ungrouptypes = [];

  for (var i = 0; i < this.types.length; i++) {
    if (this.types[i].lastIndexOf('group') !== -1) {
      grouptypes.push(this.types[i]);
    } else {
      ungrouptypes.push(this.types[i]);
    }
  }

  var sorttypes = [].concat(grouptypes, ungrouptypes);

  for (var _i = 0, len = sorttypes.length; _i < len; _i++) {
    containers[sorttypes[_i]].call(this, this.el, sorttypes[_i]);
  }
}
/**
 * Form
 * @class Form
 * @classdesc Form
 */


var Form =
/*#__PURE__*/
function () {
  /**
   * @constructor
   * @param {HtmlElement} el
   * @param {Array} types
   */
  function Form(el, types) {
    (0, _classCallCheck2["default"])(this, Form);
    this.el = el;
    this.$el = (0, _jquery["default"])(this.el);
    this.types = types;
    init.call(this);
  }
  /**
   * validatePropagation
   * @return {boolean}
   */


  (0, _createClass2["default"])(Form, [{
    key: "validatePropagation",
    value: function validatePropagation() {
      return validate.call(this, false);
    }
    /**
     * validateStopPropagation
     * @return {boolean}
     */

  }, {
    key: "validateStopPropagation",
    value: function validateStopPropagation() {
      return validate.call(this, true);
    }
    /**
     * showToolTip
     * @param {string} name
     * @param {string} tip
     */

  }, {
    key: "showToolTip",
    value: function showToolTip(name) {
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      showTip.call(this, name, tip, 'tooltip');
    }
    /**
     * showErrorTip
     * @param {string} name
     * @param {string} tip
     */

  }, {
    key: "showErrorTip",
    value: function showErrorTip(name) {
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      showTip.call(this, name, tip, 'errortip');
    }
    /**
     * showSuccessTip
     * @param {string} name
     * @param {string} tip
     */

  }, {
    key: "showSuccessTip",
    value: function showSuccessTip(name) {
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      showTip.call(this, name, tip, 'successtip');
    }
    /**
     * showRangeTip
     * @param {string} name
     * @param {string} tip
     */

  }, {
    key: "showRangeTip",
    value: function showRangeTip(name) {
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      showTip.call(this, name, tip, 'rangetip');
    }
    /**
     * hideToolTip
     * @param {string} name
     */

  }, {
    key: "hideToolTip",
    value: function hideToolTip(name) {
      hideTip.call(this, name, 'tooltip');
    }
    /**
     * hideErrorMessageTip
     * @param {string} name
     */

  }, {
    key: "hideErrorMessageTip",
    value: function hideErrorMessageTip(name) {
      hideTip.call(this, name, 'errortip');
    }
    /**
     * hideErrorMessageAllTips
     */

  }, {
    key: "hideErrorMessageAllTips",
    value: function hideErrorMessageAllTips() {
      this.$el.find('.ct-form-control.validerror,.ct-form-control.validsuccess').removeClass('validerror').removeClass('validsuccess');
      this.$el.find('.ct-form-control .errormessage').text('').hide();
    }
    /**
     * hideRangeTip
     * @param {string} name
     */

  }, {
    key: "hideRangeTip",
    value: function hideRangeTip(name) {
      hideTip.call(this, name, 'rangetip');
    }
    /**
     * hideAllTip
     * @param {string} name
     */

  }, {
    key: "hideAllTip",
    value: function hideAllTip(name) {
      hideTip.call(this, name, 'alltip');
    }
    /**
     * getEntrys
     * @return {Object}
     */

  }, {
    key: "getEntrys",
    value: function getEntrys() {
      var entrys = {};
      var formItemDom;
      var tagName;
      var checkedDoms;
      var formItemDoms = this.el.querySelectorAll('[data-ctform-config-name]');

      for (var i = 0; i < formItemDoms.length; i++) {
        formItemDom = formItemDoms[i];

        if (formItemDom.classList.contains('ct-form-radiogroup') || formItemDom.classList.contains('ct-form-checkboxgroup')) {
          if (formItemDom.classList.contains('ct-form-radiogroup')) {
            checkedDoms = formItemDom.querySelector('input[type="radio"]:checked');

            if (checkedDoms) {
              entrys[formItemDom.dataset.ctformConfigName] = checkedDoms.value ? checkedDoms.value.trim() : '';
            }
          } else {
            checkedDoms = formItemDom.querySelectorAll('input[type="checkbox"]:checked');

            if (checkedDoms && checkedDoms.length !== 0) {
              entrys[formItemDom.dataset.ctformConfigName] = Array.prototype.map.call(checkedDoms, function (t) {
                return t.value ? t.value.trim() : '';
              });
            }
          }
        } else {
          tagName = formItemDom.tagName.toLowerCase();

          if (tagName === 'input' && (formItemDom.type === 'radio' || formItemDom.type === 'checkbox')) {
            if (formItemDom.checked) {
              entrys[formItemDom.dataset.ctformConfigName] = formItemDom.value ? formItemDom.value.trim() : '';
            }
          } else {
            entrys[formItemDom.dataset.ctformConfigName] = formItemDom.value ? formItemDom.value.trim() : '';
          }
        }
      }

      return entrys;
    }
  }]);
  return Form;
}();
/**
 * FormFactory
 * @param {HtmlElement} el
 * @param {Array} types
 * @return {Form}
 */


function _default(el, types) {
  return new Form(el, types);
}